import React, { useEffect, useMemo, useState } from 'react';
import { useLayoutEffect } from 'react';
import { createPortal } from 'react-dom';
import { useSafeState } from '../../../hooks/useIsMounted';
import Close from '../../../img/icons/closeNoRing.svg';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
let timeout;

const getDistanceFromBottom = (ref) => {
  if (!ref) return 0;
  const elementRect = ref.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const distanceFromBottom = viewportHeight - elementRect.top;
  return distanceFromBottom;
}

const Notification = ({ refs, notification, setNotification }) => {
  const [domNode, setDomNode] = useSafeState();
  const [bottomRef, setBottomRef] = useState();
  const [bottomMargin, setBottomMargin] = useState(34);
  const { pathname } = useLocation();

  const reset = () => {
    clearTimeout(timeout);
    setNotification(false);
  };
  useLayoutEffect(() => {
    setDomNode(document.getElementById('notificationContainer'));
  }, []);

  const resolvedBottomRef = useMemo(() => {
    if (pathname?.includes('/bundle') || pathname?.includes('/customise')) {
      setBottomMargin(16);
      return refs.current.bannerRef;
    }
    if (refs?.current?.headerRef) {
      setBottomMargin(34);
      return refs.current.headerRef;
    }
    return null;
  }, [refs]);

  useEffect(() => {
    setBottomRef(resolvedBottomRef);
  }, [resolvedBottomRef]);

  useEffect(() => {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(reset, 2000);
  }, [notification]);

  if (domNode) {
    return createPortal(
      notification ?
        <div className="notification" style={{ bottom: bottomRef ? getDistanceFromBottom(bottomRef) + bottomMargin : 'unset' }}>
          <div
            className='block'
            style={{
              zIndex: 1,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%'
            }}
          >
            <p style={{ textAlign: 'center', paddingLeft: 16, fontFamily: 'dm-sans', fontWeight: '700' }}>
              {notification}
            </p>
            <img src={Close} onClick={reset} style={{ padding: 16 }} alt='Dismiss notification' />
          </div>
        </div> :
        <div></div>
      ,
      domNode
    );
  } else {
    return null;
  }


};

export default Notification;